// src/utils/schemaFormatters.js
import YAML from "yaml";

/**
 * Converts YAML string → internal tables array
 */
export function yamlToTables(yamlStr) {
  if (!yamlStr || typeof yamlStr !== "string") return [];
  try {
    const parsed = YAML.parse(yamlStr);
    if (!parsed?.tables || !Array.isArray(parsed.tables)) return [];
    return parsed.tables.map((t) => ({
      name: t.name || "",
      description: t.description || "",
      synapse_path: t.synapse_path || "",
      columns: (t.columns || []).map((c) => ({
        name: c.name || "",
        type: c.type || "",
        key: c.key || "",
        refTable: c.refTable || "",
        refColumn: c.refColumn || "",
        description: c.description || "",
      })),
    }));
  } catch (e) {
    console.error("❌ Failed to parse YAML:", e);
    return [];
  }
}

/**
 * Converts internal tables array → YAML string
 */
export function tablesToYaml(tables) {
  if (!tables || !Array.isArray(tables)) return "";
  const obj = {
    version: 1,
    tables: tables.map((t) => {
      const entry = {
        name: t.name,
        description: t.description,
        columns: t.columns.map((c) => ({
          name: c.name,
          type: c.type,
          key: c.key,
          refTable: c.refTable,
          refColumn: c.refColumn,
          description: c.description,
        })),
      };
      // Only include synapse_path if it has a non-empty value
      if (t.synapse_path) entry.synapse_path = t.synapse_path;
      return entry;
    }),
  };
  return YAML.stringify(obj);
}

/**
 * Converts YAML → legacy TXT format (for backend)
 */
export function yamlToTxt(yamlStr) {
  const tables = yamlToTables(yamlStr);
  let out = "";
  for (const t of tables) {
    out += `Table name: ${t.name}\n`;
    if (t.description) out += `Table description: ${t.description}\n`;
    out += `Columns:\n`;
    for (const c of t.columns) {
      let desc = c.description ? ` - ${c.description}` : "";
      let ref = "";
      if (c.key === "FK") {
        if (c.refTable && c.refColumn)
          ref = `, Foreign key referring \`${c.refTable}(${c.refColumn})\``;
        else ref = " - Foreign key (reference incomplete)";
      }
      let keyLabel = c.key === "PK" ? " - primary key" : "";
      out += `\`${c.name}\` (${c.type})${ref}${keyLabel}${desc}\n`;
    }
    out += "\n";
  }
  return out.trim();
}